import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  wellbeingField: {
    '& input': {
      textAlign: 'center'
    }
  }
})

export default useStyles
